module.exports = __webpack_public_path__ + "static/comprehensive-image-infected-58bcf04c1bde870c114c5bf57206ac36.png";